import { http } from './http';
import { ROUTES } from './config';
import type { Testimonial, TestimonialInput, PublicTestimonial } from '../types/domain';

/** TestimonialsController client (manager+ CRUD; /public is anonymous). */
export const testimonialsApi = {
  list(): Promise<Testimonial[]> {
    return http.get(ROUTES.testimonials.base);
  },

  /** Published testimonials in display order. `featured: true` returns only the home-page selection. */
  getPublic(featured?: boolean): Promise<PublicTestimonial[]> {
    const q = featured ? '?featured=true' : '';
    return http.get(`${ROUTES.testimonials.public}${q}`, { anonymous: true });
  },

  create(body: TestimonialInput): Promise<{ id: string }> {
    return http.post(ROUTES.testimonials.base, body);
  },

  update(id: string, body: TestimonialInput): Promise<void> {
    return http.put(`${ROUTES.testimonials.base}/${id}`, body);
  },

  remove(id: string): Promise<void> {
    return http.delete(`${ROUTES.testimonials.base}/${id}`);
  },
};
